<template>
  <div class="main">
    <div>
      <div class="header">
        <img
          src="~@/assets/icons/return.svg"
          style="position: absolute; top: 32px; left: 32px; cursor: pointer"
          @click="$emit('goToDashboard')"
        />
        <img class="logo" :src="selfServiceLogo" />
        <span class="text--m text--bold">{{selfServiceAlias}}</span>
      </div>
      <div class="progress-container"><ProgressLinear :value="projectProgress" style="width: 70%" /></div>
    </div>

    <div class="sections">
      <div
        v-for="(section, i) in sections"
        :key="i"
        class="section"
      >
        <div class="p-2 heading">
          <span class="">{{section.title}}</span>
        </div>
        <div class="task-group">
          <div
            v-for="(task, k) in section.actions"
            :key="k"
            class="task p-1"
            :class="selectedTaskId === task.id ? 'task--active' : null"
            @click="$emit('taskSelected', task.id)"
          >
<!--            <div-->
<!--              class="checkmark mr-2"-->
<!--              :class="{ completed: task.completed }"-->
<!--              @click.stop.prevent="task.completed = !task.completed"-->
<!--              v-tooltip="{ content: `Mark task as ${task.completed ? 'incomplete' : 'complete'}` , delay: 500 }"-->
<!--            ></div>-->
            <img
              v-if="task.completed"
              class="mr-2"
              src="~@/assets/icons/check_circle.svg"
            />
            <img
              v-else
              class="mr-2"
              src="~@/assets/icons/radio_button_unchecked.svg"
            />
            <span style="cursor: pointer">{{taskIndex[task.id]}}{{task.title}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProgressLinear from "@/components/SelfService/ProgressLinear";
export default {
  name: "SelfServiceTaskBar",
  components: {ProgressLinear},
  props: {
    sections: {
      type: Array,
      default: () => []
    },
    selectedTask: {
      type: Object,
      default: () => null
    },
    selectedTaskId: {
      type: Number,
      default: null
    }
  },
  data: () => ({
  }),
  computed: {
    projectProgress() {
      const allTasks = this.sections.reduce((tasks, el) => Array.isArray(el.actions) ? tasks.concat(el.actions) :  tasks, [])
      const completedTasks = allTasks.reduce((compCount, el) => el.completed ? compCount + 1 :  compCount, 0)

      return Math.round(completedTasks / allTasks.length * 100)
    },
    selfServiceLogo(){
      return this.$store.getters.selfServiceLogo;
    },
    selfServiceAlias(){
      return this.$store.getters.selfServiceAlias;
    },
    taskIndex() {
      let i = 0;
      const actions = this.sections.reduce((acc, curr) => {
        return [...acc, ...curr.actions];
      }, []);

      return actions.reduce((acc, curr) => {
        acc[curr.id] = curr.title === 'Welcome' ? '' : `${++i}. `;
        return acc;
      }, {});
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/SelfService/spacing.scss";
@import "~@/styles/SelfService/typography.scss";

.main {
  min-height: 100%;
  padding: $spacing--m;
  display: flex;
  flex-direction: column;
}

.logo{
  height: 44px;
  padding: $spacing--xs;
}

.header {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.progress-container{
  //display: flex;
  //justify-content: center;
  padding-top: $spacing--m;
}

.sections{
  flex-grow: 1;
  overflow-y: auto;
}

.section {
  span{
    font-size: $font-size--m;
  }

  .heading {
    font-weight: 600;
  }

  .task-group{
    padding-left: $spacing--l;

    .task{
      display: flex;
      align-items: center;

      .checkmark {
        opacity: 1;
        width: 18px;
        height: 18px;
        background-image: url(~@/assets/icons/completedIcons.svg);
        background-position: top center;
        background-repeat: no-repeat;
        background-size: 18px 72px;

        &:hover {
          opacity: 1;
          background-position: top -18px center;
        }

        &.completed,
        &.completed:hover {
          opacity: 1;
          background-position: top -36px center;
        }

        &.overdue,
        &.overdue:hover {
          opacity: 1;
          background-position: top -54px center;
        }
      }
    }

    .task.task--active{
        font-weight: 600;
    }
  }
}

::-webkit-scrollbar {
  display: none;
}
</style>
